export const FOCUS_TO_CREATE_MEASURE_NAME = 'focus-text-area-to-issue-create-duration';
export const FOCUS_TO_CREATE_START_MARK = `${FOCUS_TO_CREATE_MEASURE_NAME}:start`;
export const FOCUS_TO_CREATE_END_MARK = `${FOCUS_TO_CREATE_MEASURE_NAME}:end`;
